import React from 'react';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import Modal from 'react-modal';
import { SettingsModalContent } from '../../../../shared/settings-modal-content/settings-modal-content';
import { autoId, useReactModal } from '@workday/upc-common';
import { ID_DELETE_ACCOUNT_BUTTON } from '../../../../autoIds';
import { DeleteAccountSteps } from './delete-account-steps';
import { useTranslation } from 'react-i18next';

export function DeleteAccountSettingsRow() {
    const deleteAccountModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });

    const { t } = useTranslation('account');

    function onOpenModal() {
        deleteAccountModal.open();
    }

    function onCloseModal() {
        deleteAccountModal.close();
    }

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('DeleteAccountSettingsRow.title')}</h1>
            <div className='settingsRow__content'>
                <p>{t('DeleteAccountSettingsRow.description')}</p>
                <SecondaryButton {...autoId(ID_DELETE_ACCOUNT_BUTTON)} type='button' onClick={onOpenModal}>
                    {t('DeleteAccountSettingsRow.openModalButton')}
                </SecondaryButton>
                <Modal {...deleteAccountModal.modalProps}>
                    <SettingsModalContent>
                        <DeleteAccountSteps onClose={onCloseModal} />
                    </SettingsModalContent>
                </Modal>
            </div>
        </div>
    );
}
